"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snippet = Snippet;
var _utils = require("instantsearch.js/cjs/lib/utils");
var _react = _interopRequireDefault(require("react"));
var _Snippet = require("../ui/Snippet");
var _excluded = ["hit", "attribute", "highlightedTagName", "nonHighlightedTagName", "separator"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function Snippet(_ref) {
  var hit = _ref.hit,
    attribute = _ref.attribute,
    highlightedTagName = _ref.highlightedTagName,
    nonHighlightedTagName = _ref.nonHighlightedTagName,
    separator = _ref.separator,
    props = _objectWithoutProperties(_ref, _excluded);
  var property = (0, _utils.getPropertyByPath)(hit._snippetResult, attribute) || [];
  var properties = Array.isArray(property) ? property : [property];
  var parts = properties.map(function (singleValue) {
    return (0, _utils.getHighlightedParts)((0, _utils.unescape)(singleValue.value || ''));
  });
  return /*#__PURE__*/_react.default.createElement(_Snippet.Snippet, _extends({}, props, {
    parts: parts,
    highlightedTagName: highlightedTagName,
    nonHighlightedTagName: nonHighlightedTagName,
    separator: separator
  }));
}